/**
 * Converts a string into slug format/kebab-case.
 * @param {string} property
 * @return A slug version of the string.
 */
export function slugify(string) {
  if (!string) {
    return ""
  }

  // prettier-ignore
  const charMap = [
    ['à', 'a'], ['á', 'a'], ['â', 'a'], ['ä', 'ae'],
    ['è', 'e'], ['é', 'e'], ['ê', 'e'], ['ë', 'e'],
    ['ì', 'i'], ['í', 'i'], ['î', 'i'], ['ï', 'i'],
    ['ò', 'o'], ['ó', 'o'], ['ô', 'o'], ['ö', 'oe'],
    ['ù', 'u'], ['ú', 'u'], ['û', 'u'], ['ü', 'ue'],
    ['ç', 'c'], ['ñ', 'n'], ['ß', 'ss'],
    ['·', '-'], ['/', '-'], ['_', '-'], [',', '-'], [':', '-'], [';', '-']
  ];

  string = string.trim()
  string = string.toLowerCase()

  for (let i = 0; i < charMap.length; i++) {
    string = string.replace(new RegExp(charMap[i][0], "g"), charMap[i][1])
  }

  string = string
    .replace(/[^a-z0-9 -]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")

  // prepend "id" if string starts with number since html ids are not allowed to start with a number
  if (!isNaN(string.charAt(0))) {
    string = "id" + string
  }

  return string
}
